import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Services = () => import('@/pages/Services')
const ServiceEdition = () => import('@/pages/ServiceEdition')
const ServiceCreation = () => import('@/pages/ServiceCreation')

export default [
  {
    path: '/services',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Services',
        component: Services,
        props: route => route.query
      },
      {
        path: 'new',
        name: 'ServiceCreation',
        component: ServiceCreation
      },
      {
        path: ':id',
        name: 'Service',
        component: ServiceEdition,
        props: route => ({
          id: parseInt(route.params.id, 10)
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/services.route.js